module.exports = __webpack_public_path__ + "img/amenities-03.47cec4d4.jpg";